import { isGroupBooking } from './isGroupBooking';
import serviceTypeCodes from 'constants/serviceTypeCodes';

export const shouldFetchBookedAssistancesPerCoaches = ({
  productFamily,
  pendingCreationLegs = [],
  pendingCancellationLegs = [],
  direction,
  isMYB = false
}) => {
  if (isGroupBooking(productFamily)) return false;
  const pendingCreationLegsPerDirection = pendingCreationLegs.filter((leg) => leg.direction === direction);
  const pendingCancellationLegsPerDirection = pendingCancellationLegs.filter((leg) => leg.direction === direction);
  return (
    (pendingCancellationLegsPerDirection.length === 1 || pendingCreationLegsPerDirection.length === 1 || isMYB) &&
    (pendingCancellationLegsPerDirection.every((leg) => leg.serviceType?.code === serviceTypeCodes.EUROSTAR) ||
      pendingCreationLegsPerDirection.every((leg) => leg.serviceType?.code === serviceTypeCodes.EUROSTAR))
  );
};
